import { headerOffset, jumpTo, readingTarget, unmodifiedActivation } from '../../assets/js/main/core/anchors';

// Jump links work across nested block layouts and support collapsed sections.
function setup() {
  const pairs = Array.from(document.querySelectorAll('.content-overview-list a')).map(link => {
    const raw = link.hash.slice(1);
    let section = document.getElementById(raw);
    if (!section) {
      try { section = document.getElementById(decodeURIComponent(raw)); } catch { return null; }
    }
    return section ? {link, section} : null;
  }).filter(Boolean);
  if (!pairs.length) return;
  const offset = () => headerOffset(readingTarget(pairs[0].section));
  pairs.forEach(({link,section}) => link.addEventListener('click',event => {
    if (!unmodifiedActivation(event)) return;
    event.preventDefault();
    jumpTo(section, { hash: link.hash, keyboard: event.detail === 0 });
  }));
  let pending = false;
  const update = () => {
    pending = false;
    let best = pairs[0];
    pairs.forEach(pair => { if (pair.section.getBoundingClientRect().top <= offset()+20) best = pair; });
    pairs.forEach(({link}) => {
      const active = link === best.link;
      link.classList.toggle('active',active);
      if (active) link.setAttribute('aria-current','location'); else link.removeAttribute('aria-current');
    });
  };
  window.addEventListener('scroll',()=>{if(!pending){pending=true;window.requestAnimationFrame(update);}},{passive:true});
  window.addEventListener('resize',update);
  update();
}
if (!window.cotoOverviewController) {
  window.cotoOverviewController = true;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',setup); else setup();
}
